"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var DateError = /** @class */ (function () {
    function DateError(message) {
        this.message = message;
    }
    return DateError;
}());
exports.DateError = DateError;
exports.leadingZero = function (dateToConfigure) {
    return dateToConfigure.length > 0 ?
        ("0" + dateToConfigure).slice(-2) : dateToConfigure;
};
exports.formatYear = function (yearToFormat) {
    if (yearToFormat.length === 2) {
        yearToFormat = "19" + yearToFormat;
        var parseYear = function () {
            return parseInt(moment().subtract(90, 'years').format('YYYY'), 10);
        };
        return parseYear() > parseInt(yearToFormat, 10) ?
            "20" + yearToFormat.slice(-2) : yearToFormat;
    }
    return yearToFormat;
};
/**
 * Creates a Date from year, month, date
 *
 * @param year
 * @param month
 * @param day
 * @returns {Date}
 */
exports.createDate = function (year, month, day) {
    var parts = [year, month, day];
    parts.forEach(function (part) {
        if (!part) {
            throw new DateError('Invalid date, missing part');
        }
    });
    year = exports.formatYear(year);
    month = exports.leadingZero(month);
    day = exports.leadingZero(day);
    var date = new Date(Date.UTC(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10)));
    if (date.getUTCFullYear() !== parseInt(year, 10) ||
        date.getUTCMonth() !== parseInt(month, 10) - 1 ||
        date.getUTCDate() !== parseInt(day, 10)) {
        throw new DateError('Invalid date');
    }
    return date;
};
/**
 * Creates a Y-m-d formatted string
 *
 * @param dateObject
 * @returns {string}
 */
exports.objectToString = function (dateObject) {
    var date = exports.createDate(dateObject.year, dateObject.month, dateObject.day);
    var zeroPadToTwo = function (num) { return ("" + num).length === 2 ? "" + num : "0" + num; };
    return [
        date.getUTCFullYear(),
        zeroPadToTwo(date.getUTCMonth() + 1),
        zeroPadToTwo(date.getUTCDate())
    ].join('-');
};
/**
 * Converts a Y-m-d formatted string
 *
 * @param dateString
 * @returns {{day: string, month: string, year: string}}
 */
exports.stringToObject = function (dateString) {
    var splitDate = ("" + dateString).split('-');
    if (splitDate.length !== 3) {
        throw new DateError("Invalid date format: " + dateString);
    }
    var date = exports.createDate(splitDate[0], splitDate[1], splitDate[2]);
    return {
        day: exports.leadingZero("" + date.getUTCDate()),
        month: exports.leadingZero("" + (date.getUTCMonth() + 1)),
        year: "" + date.getUTCFullYear()
    };
};
